import qs from 'qs';
import jsonp from './jsonp';
export const ADDWISH_GET_PRODUCTBOXES_URL = `https://www.addwish.com/api/v1/product-recommendation/getProductBoxes`;
export function loadAddwishScript(id) {
    if (typeof window === 'undefined') {
        return;
    }
    const aws = document.createElement('script');
    aws.type = 'text/javascript';
    if (typeof aws.async != 'undefined') {
        aws.async = true;
    }
    aws.src =
        (window.location.protocol == 'https:'
            ? 'https://d1pna5l3xsntoj.cloudfront.net'
            : 'http://cdn.addwish.com') + `/scripts/company/awAddGift.js#${id}`;
    const s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(aws, s);
}
function checkScriptLoadedOrThrow() {
    if (typeof window === 'undefined') {
        throw new Error('Addwish is client only');
    }
    if (!window.ADDWISH_PARTNER_NS) {
        throw new Error('Addwish client not loaded');
    }
}
export function reloadAddwish() {
    if (isAddwishLoaded()) {
        window.ADDWISH_PARTNER_NS.api.reload();
    }
}
export function isAddwishLoaded() {
    return typeof window !== 'undefined' && !!window.ADDWISH_PARTNER_NS;
}
export function setAddwishCart(cart) {
    return new Promise((resolve, reject) => {
        try {
            checkScriptLoadedOrThrow();
            window.ADDWISH_PARTNER_NS.api.cart.setCart(cart, () => {
                resolve();
            });
        }
        catch (err) {
            reject(err);
        }
    });
}
export function fetchAddwishRecommendations({ ids, url, signal }) {
    const addwishUrl = `${ADDWISH_GET_PRODUCTBOXES_URL}?${qs.stringify({
        format: 'json',
        url,
        ids: ids.join(','),
        _: Date.now() // cache busting
    })}`;
    return jsonp(addwishUrl, {
        param: 'jsonp',
        timeout: 10e3,
        signal
    });
}
export function trackCartCheckout(args, _context) {
    setAddwishCart({
        productNumbers: args.cart.items.map(product => product.articleNumber),
        total: args.cart.productTotal.incVat + '',
        url: `${document.location.protocol}//${document.location.hostname}/externalcheckout.aspx?cartid=${args.cart.id}`
    });
}
export const addwishTracker = ({ id }) => ({
    name: 'addwish',
    initBrowser() {
        loadAddwishScript(id);
    },
    trackPageView() {
        reloadAddwish();
    },
    trackCartCheckout(props, context) {
        trackCartCheckout(props, context);
    }
});
//# sourceMappingURL=addwishAPI.js.map